module.exports = __webpack_public_path__ + "img/cover-5.d9eb299b.jpg";